import React, { useEffect } from "react";
import Tiles from "./Tiles";
import { useDispatch, useSelector } from "react-redux";
import { getTotalQuestionCount, getTotalUserCount } from "../../../../API/api";
import { bindActionCreators } from "redux";
import { Actions } from "../../../../Action/index";
import { Grid, Typography, Box, Paper } from "@mui/material";
import GraphComponent from "../../../GraphComponent/GraphComponent";
import VizHeader from "../../../VizHeader/VizHeader";
import SelectSourceComponentOverview from "../../../SelectSourceComponentOverview/SelectSourceComponentOverview";
import SelectComponentForOverview from "../../../SelectComponentForOverview/SelectComponentForOverview";
import SelectComponentForQuestionsSubmitted from "../../../SelectMonthsDurationCMGraphs/SelectComponentForQuestionsSubmitted";
import SelectComponentForMonthsAnsweredByVizerto from "../../../SelectMonthsDurationCMGraphs/SelectComponentForMonthsAnsweredByVizerto";
import SelectMonthsDurationForTrendingSearch from "../../../SelectMonthsDurationCMGraphs/SelectMonthsDurationForTrendingSearch";
import MiniDrawer from "../../../newNavBarCM/newNavBar";

const containerStyle = {
  width: "100%",
  margin: "auto",
  marginTop: "1%",
  marginBottom: "1%",
  border: "1px solid #E0E2E6",
  background: "#FFFFFF",
  borderRadius: "12px",
  boxShadow: "0px 4px 16px 0px #1018280F",
  padding: "28px",

};

export default function Overview() {
  const state = useSelector((state) => state);
  const expertOverview = useSelector((state) => state.expertOverviewCmReducer);
  const overviewReducer = useSelector((state) => state.cmOverview);
  const dispatch = useDispatch();
  const { cmOverViewTotalCountData } = bindActionCreators(Actions, dispatch);
  const fetchTotalCount = () => {
    getTotalQuestionCount(
      state.cmRoot.selecetdRoutingValue,
      state.cmRoot.selectedGeoLevel.length === 0
        ? ""
        : state.cmRoot.selectedGeoLevel.label,
      state.cmRoot.selectedDomainIds,
      overviewReducer.userTypeSelect.value
    ).then((res) => {
      if (res===undefined) return;
      getTotalUserCount(
        state.cmRoot.selecetdRoutingValue,
        state.cmRoot.selectedGeoLevel.length === 0
          ? ""
          : state.cmRoot.selectedGeoLevel.label,
        state.cmRoot.selectedDomainIds,
        overviewReducer.userTypeSelect.value
      ).then((res2) => {
        if (res2===undefined) return;
        cmOverViewTotalCountData({ ...res.data.data, ...res2.data.data });
      });
    });
  };
  useEffect(() => {
    if (state.cmRoot.selecetdRoutingValue !== "") {
      fetchTotalCount();
    }
  }, [state.cmRoot.selecetdRoutingValue, overviewReducer.userTypeSelect,state.cmRoot.selectedDomainIds, state.cmRoot.selectedGeoLevel]);


  return (
    <div style={containerStyle}>
 <div style={{ paddingTop: "15px", }}>
      <div className="mt-2">
        <Tiles />
      </div>
      <Grid container paddingTop={2} paddingBottom={2} xs={12} md={12}>
        <Grid item xs={12}>
          <Paper>
            {/* <Grid container paddingTop={1} paddingBottom={1}>
              <Grid item xs={8}></Grid>
              <Grid item xs={4}>
                <Box display="flex" justifyContent="flex-end" alignItems={"center"}>
                  <div style={{ width: "50%", paddingRight: "12px" }}>
                    <SelectComponentMonthsDuration />
                  </div>
                  <Dropdown
                    menu={{
                      items,
                    }}
                  >
                    <a onClick={(e) => e.preventDefault()}>
                      <i
                        className="fa fa-ellipsis-h"
                        style={{ fontSize: "20px", color: "lightgray",padding:'5px' }}
                      ></i>
                    </a>
                  </Dropdown>
                </Box>
              </Grid>
            </Grid> */}
            <GraphComponent
              type="Multiple"
              name="Questions Searched/Submitted/Answered"
            />
          </Paper>
        </Grid>
      </Grid>
      <Grid container paddingTop={2} paddingBottom={2} xs={12} md={12}>
        <Grid item xs={12}>
          <Paper>
            <GraphComponent type="Line" name="Questions Submitted to Experts" />
          </Paper>
        </Grid>
      </Grid>
      <Grid container paddingTop={2} paddingBottom={2} xs={12} md={12}>
        <Grid item xs={12}>
          <Paper>
            <GraphComponent type="Composed" name="Answered By Vizerto" />
          </Paper>
        </Grid>
      </Grid>
      <Grid container paddingTop={2} paddingBottom={2} xs={12} md={12}>
        <Grid item xs={12} >
          <Paper>
            {/* <Grid container paddingTop={1} paddingBottom={1}>
              <Grid item xs={8}></Grid>
              <Grid item xs={4}>
                <Grid container>
                  <div style={{ marginRight: "5px", width: "48%" }}>
                    <SelectComponentForOverview />
                  </div>
                  <div style={{ width: "50%", paddingRight: "12px" }}>
                    <SelectMonthsDurationForTrendingSearch />
                  </div>
                </Grid>
              </Grid>
            </Grid> */}
            <GraphComponent type="Area" name="Trending Search" />
          </Paper>
        </Grid>
      </Grid>
      <Grid
        container
        paddingTop={2}
        paddingBottom={6}
        xs={12}
        md={12}
      >
        <Grid item xs={12} sm={12}>
          <Paper>
            <GraphComponent
              type="PieDomains"
              name="Question Volume By Domain"
            />
          </Paper>
        </Grid>
        {/* <Grid item xs={6}>
            <Paper>
              <div style={{textAlign:'center'}}><VizHeader type={4}>Question Status Breakdown</VizHeader></div>
              <GraphComponent type="BarChartBreakdown" name="Question Status Breakdown"/>
              </Paper>
            </Grid> */}
      </Grid>
    </div>
    </div>
   
  );
}
